var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28906 0.914062L6.375 4.87891V3.375C6.375 1.92578 7.55078 0.75 9 0.75C10.4492 0.75 11.625 1.92578 11.625 3.375V8.98047L12.0898 9.36328C12.3359 8.89844 12.5 8.35156 12.5 7.75V6.65625C12.5 6.30078 12.7734 6 13.1562 6C13.5117 6 13.8125 6.30078 13.8125 6.65625V7.75C13.8125 8.65234 13.5664 9.47266 13.1562 10.1836L17.4766 13.6016C17.7773 13.8203 17.832 14.2305 17.5859 14.5039C17.3672 14.8047 16.957 14.8594 16.6836 14.6133L0.496094 1.92578C0.195312 1.70703 0.140625 1.29688 0.386719 1.02344C0.605469 0.722656 1.01562 0.667969 1.28906 0.914062ZM11.2148 12.043C10.7227 12.2891 10.2031 12.4531 9.65625 12.5352V13.4375H10.9688C11.3242 13.4375 11.625 13.7383 11.625 14.0938C11.625 14.4766 11.3242 14.75 10.9688 14.75H9H7.03125C6.64844 14.75 6.375 14.4766 6.375 14.0938C6.375 13.7383 6.64844 13.4375 7.03125 13.4375H8.34375V12.5352C5.99219 12.207 4.1875 10.2109 4.1875 7.75V6.65625C4.1875 6.60156 4.1875 6.54688 4.1875 6.49219L5.5 7.53125V7.75C5.5 9.69141 7.05859 11.25 9 11.25C9.35547 11.25 9.71094 11.1953 10.0391 11.1133L11.2148 12.043Z",
    fill: "#F63135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic-off.5376c57221e5164a7da788d7ea3b0b13.svg";
export { ForwardRef as ReactComponent };